/*** IMPORTS FROM imports-loader ***/
var define = false;

const DEFAULTS = {
    method: 'GET',
    responseType: 'json',
}

export default class Ajax {
    constructor(options = {}) {
        this.options = {
            ...DEFAULTS,
            ...options
        }

        if(this.options.method === 'GET' && this.options.data) {
            const query = new URLSearchParams(this.options.data).toString()
            this.options.url += query ? '?' + query : ''
        }

        this.xhr = new XMLHttpRequest()
        this.xhr.open(this.options.method, this.options.url)
        this.xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
        this.xhr.responseType = this.options.responseType
        this.xhr.onload = () => {
            if(this.xhr.status != 200) {
                this.options.onError(this.xhr.status, this.xhr.statusText)
                return
            }

            this.options.onSuccess(this.xhr.response)
        }
        this.xhr.onerror = this.options.onError
        this.xhr.onloadstart = this.options.onLoadStart
        this.xhr.onloadend = this.options.onLoadEnd

        if(this.options.method === 'GET') {
            this.xhr.send()
        } else {
            this.xhr.send(this.options.data)
        }
    }

    abort() {
        this.xhr.abort()
    }
}
